import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isMultiSelect", "isDisabled", "variant", "selectedTopics", "onChange"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import groupBy from 'utils/groupBy';
import Pill from 'components/Pill';
import InlineList from 'components/InlineList';
import Modal from 'components/Modal';
import Flex from 'components/Flex';
import HintTooltip from 'components/HintTooltip';
import Text from 'components/Text';
import Stack from 'components/Stack';
import FormField, { useFormFieldContext } from 'components/FormField';
import TopicSelector from 'screens/TopicSelector';
import AddOrEditButton from './utils/AddOrEditButton';
function TopicList(_ref) {
  var topics = _ref.topics,
    title = _ref.title,
    description = _ref.description;
  var _useFormFieldContext = useFormFieldContext(),
    labelId = _useFormFieldContext.labelId;
  var titleId = useUniqueId();
  if (title) {
    return /*#__PURE__*/React.createElement(Stack, {
      spacing: "xs",
      role: "group",
      "aria-labelledby": titleId
    }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Text, {
      id: titleId
    }, title), /*#__PURE__*/React.createElement(HintTooltip, {
      content: description,
      spacingLeft: "xs",
      vAlign: false
    })), /*#__PURE__*/React.createElement(InlineList, {
      spacing: "xxs",
      "aria-labelledby": labelId
    }, topics.map(function (topic) {
      return /*#__PURE__*/React.createElement(Pill, {
        key: topic.id,
        icon: "topic"
      }, topic.name);
    })));
  }
  return /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xxs",
    "aria-labelledby": labelId,
    align: "middle"
  }, topics.map(function (topic) {
    return /*#__PURE__*/React.createElement(Pill, {
      key: topic.id,
      icon: "topic"
    }, topic.name);
  }));
}
function TopicField(_ref2) {
  var _ref2$isMultiSelect = _ref2.isMultiSelect,
    isMultiSelect = _ref2$isMultiSelect === void 0 ? false : _ref2$isMultiSelect,
    isDisabled = _ref2.isDisabled,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'transparent' : _ref2$variant,
    selectedTopics = _ref2.selectedTopics,
    onChange = _ref2.onChange,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTopicEditorModalOpen = _useState2[0],
    setTopicEditorModalOpen = _useState2[1];
  var _groupBy = groupBy(selectedTopics, function (topic) {
      if (topic.isIndeterminate) {
        return 'indeterminateTopics';
      }
      return 'commonTopics';
    }),
    _groupBy$indeterminat = _groupBy.indeterminateTopics,
    indeterminateTopics = _groupBy$indeterminat === void 0 ? [] : _groupBy$indeterminat,
    _groupBy$commonTopics = _groupBy.commonTopics,
    commonTopics = _groupBy$commonTopics === void 0 ? [] : _groupBy$commonTopics;
  return /*#__PURE__*/React.createElement(FormField, _extends({
    as: "span",
    label: t('content_type_topic_plural')
  }, otherProps), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, commonTopics.length > 0 && /*#__PURE__*/React.createElement(TopicList, {
    topics: commonTopics,
    title: isMultiSelect ? t('property_common') : undefined,
    description: isMultiSelect ? t('hint_topics_playlist_common', {
      count: commonTopics.length
    }) : undefined
  }), indeterminateTopics.length > 0 && /*#__PURE__*/React.createElement(TopicList, {
    title: t('property_individual'),
    description: t('hint_topics_playlist_individual', {
      count: indeterminateTopics.length
    }),
    topics: indeterminateTopics
  }), /*#__PURE__*/React.createElement(AddOrEditButton, {
    isEditMode: !!selectedTopics.length,
    addText: t('actions_add_topics'),
    editText: t('actions_edit_topics'),
    variant: variant,
    onClick: function onClick() {
      return setTopicEditorModalOpen(true);
    },
    isDisabled: isDisabled
  })), isTopicEditorModalOpen && /*#__PURE__*/React.createElement(Modal, {
    id: "topic-editor-modal",
    "aria-label": t('actions_assign_topics'),
    onRequestClose: function onRequestClose() {
      return setTopicEditorModalOpen(false);
    }
  }, /*#__PURE__*/React.createElement(TopicSelector, {
    initialSelected: selectedTopics,
    initialIndeterminate: indeterminateTopics,
    onChangeSelectedTopics: onChange,
    onClose: function onClose() {
      return setTopicEditorModalOpen(false);
    }
  })));
}
export default TopicField;